import React, { useState } from "react";
import ForecastHourly from "./ForecastHourly";
import axios from "axios";
//import "./WeatherForecast.css"

export default function WeatherForecast(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  function handleForecastResoponse(response) {
    setForecast(response.data);
    setLoaded(true);
  }
  if (loaded && props.city === forecast.city.name) {
    return (
      <div className="WeatherForecast row">
        <ForecastHourly data={forecast.list[0]} />
        <ForecastHourly data={forecast.list[1]} />
        <ForecastHourly data={forecast.list[2]} />
        <ForecastHourly data={forecast.list[3]} />
        <ForecastHourly data={forecast.list[4]} />
        <ForecastHourly data={forecast.list[5]} />
      </div>
    );
  } else {
    let apiKey = `8c11abc58f55fcd41b913c1bd205ce06`;
    let url = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=${apiKey}&units=metric`;
    axios.get(url).then(handleForecastResoponse);

    return null;
  }
}
